import {connect} from 'react-redux';
import * as chapterPartActions from '../../store/actions/chapterPartActions';
import EditTest from '../../components/AdminPanel/EditTest';
import * as VideoActions from '../../store/actions/videoActions';
import * as CoursesActions from '../../store/actions/coursesActions';


const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.chapterPart,
    ...state.video,
    ...state.courses
});

const mapDispatchToProps = (dispatch) => ({
    loadBlank: () => {
        dispatch(chapterPartActions.loadBlanks());
    },
    loadTestTemplates: (token) => {
        dispatch(chapterPartActions.getChapterTestTemplates(token));
    },
    saveTest: (test, token) => {
        if(test.courseSubjectId){
            dispatch(chapterPartActions.updateChapterTest(test, token));
        }else{
            dispatch(chapterPartActions.updateChapterTestTemplate(test, token));
        }
    },
    saveDiagnosticTest: (test, token) => {
      dispatch(CoursesActions.updateTest(test, token));
  
    },
    getTest: (id, token) => {
        dispatch(chapterPartActions.getChapterTest(id, token));
    },
    uploadFile: (data, profileId, type, token) => {
        dispatch(chapterPartActions.uploadFile(data, profileId, type, token));
    },
    updateTest: (test) => {
        dispatch(chapterPartActions.updateTest(test));
    },
    addTestQuestion: (partial, section) => {
        dispatch(chapterPartActions.addTestQuestion(partial, section));
    },
    addTestQuestionWithData: (q, section) => {
        dispatch(chapterPartActions.addTestQuestionWithData(q, section));
    },
    addTestSection: () => {
        dispatch(chapterPartActions.addTestSection());
    },
    updateSectionField: (index, field, value) => {
        dispatch(chapterPartActions.updateSectionField(index, field, value));
    },
    updateQuestion: (sectionIndex, index, field, value) => {
        dispatch(chapterPartActions.updateTestQuestion(sectionIndex, index, field, value));
    },
    deleteQuestion: (params) => {
        dispatch(chapterPartActions.deleteTestQuestion(params));
    },
    deleteSubSection: (params) => {
        dispatch(chapterPartActions.deleteSubSection(params));
    },
    deleteSection: (params) => {
        dispatch(chapterPartActions.deleteSection(params));
    },
    deleteTest: (id, token) => {
        dispatch(CoursesActions.deleteCourseTest(id, token));
    },
    resetTestTemplate: () => {
        dispatch(chapterPartActions.resetTestTemplate());
    },
    loadChapterTest: (testId, token) => {
        dispatch(chapterPartActions.loadChapterTest(testId, token));
    },
    loadDiagnosticTest: (testId, token) => {
        dispatch(chapterPartActions.loadDiagnosticTest(testId, token));
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditTest);


// WEBPACK FOOTER //
// ./src/containers/AdminPanel/EditTestContainer.js